import { OperationEntity } from 'api/types/entity/operation';
import { convertDateByTimezone, yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';
import { OperationFormType } from 'modules/operation/common/forms/operationForm';

export const getOperationInitialValue = (
  t: TFunc,
  operation: OperationEntity,
  brokerTimezoneOffset: number
): Partial<OperationFormType> => ({
  clientType: {
    label: t(`primaryClientType.${operation.order.ownerType}`),
    value: operation.order.ownerType,
  },
  client: {
    label: operation.order.ownerFullName || '',
    value: operation.order.ownerId,
    record: {
      id: operation.order.ownerId,
      name: operation.order.ownerFullName || '',
      personalAccountNumber: operation.order.ownerPersonalAccountNumber || '',
    },
  },
  order: {
    label: operation.order.number.toString(),
    value: operation.order.id,
    record: {
      id: operation.order.id,
      number: operation.order.number,
      ownerId: operation.order.ownerId,
      ownerType: operation.order.ownerType,
      status: operation.order.status,
      operationType: operation.order.operationType,
      startDate: operation.order.startDate,
      endDate: operation.order.endDate,
      orderType: operation.order.orderType,
      marketType: operation.order.marketType,
      isin: operation.order.isin,
      issueCode: operation.order.issueCode,
      securityType: operation.order.securityType,
      nominalValue: operation.order.nominalValue,
      currency: operation.order.currency,
    },
  },
  number: operation.number,
  executedAt: operation.executedAt,
  executionPlace: operation.executionPlace
    ? {
        label: operation.executionPlace.name || '',
        value: operation.executionPlace.id,
      }
    : undefined,
  executionMethod: operation.executionMethod
    ? {
        label: t(
          `operation.operationExecutionMethod.${operation.executionMethod}`
        ),
        value: operation.executionMethod,
      }
    : null,
  isSpecializedTrade: yesOrNotOption(t, operation.isSpecializedTrade),
  trader: operation.trader
    ? {
        label: operation.trader.name,
        value: operation.trader.id,
      }
    : null,
  counterpartyName: operation.counterpartyName || '',
  quantity: operation.quantity,
  netUnitPrice: operation.netUnitPrice,
  unitPrice: operation.unitPrice || '',
  accruedCouponIncome: operation.accruedCouponIncome || '',
  volume: operation.volume || '',
  settlementDate: convertDateByTimezone(
    operation.settlementDate,
    brokerTimezoneOffset
  ),
  exchangeRate: operation.exchangeRate || '',
  files: operation.confirmationFiles || [],
  additionalNotes: operation.additionalNotes || '',
});
